import { render, staticRenderFns } from "./BarraLateral.vue?vue&type=template&id=5dc083b8&scoped=true&"
import script from "./BarraLateral.vue?vue&type=script&lang=js&"
export * from "./BarraLateral.vue?vue&type=script&lang=js&"
import style0 from "./BarraLateral.vue?vue&type=style&index=0&id=5dc083b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc083b8",
  null
  
)

export default component.exports